import { useMemo, useState } from 'react';
import {
  BackgroundControlWithFiles,
  BackgroundControlWithFilesRiskEnum,
  FindAllFrameCompaniesResponse,
} from '@ansvar-sakerhet/api-client';
import React from 'react';
import { findLatestReport } from '../utils/findLatestReport';
import { getReportFileName } from '../../../../../../../traits/api/controls/getReportFileName';
import { OrderBackgroundControlButton } from '../../OrderBackgroundControlButton';
import { DownloadReportButton } from '../../DownloadReportButton';
import { sortFrameCompanies } from '../utils/sortFrameCompanies';

export enum SortControls {
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  RegistrationNumberAsc = 'registrationNumber_ASC',
  RegistrationNumberDesc = 'registrationNumber_DESC',
  LatestBackgroundControlAsc = 'latestBackgroundControl_ASC',
  LatestBackgroundControlDesc = 'latestBackgroundControl_DESC',
  BackgroundControlResultAsc = 'backgroundControlStatus_ASC',
  BackgroundControlResultDesc = 'backgroundControlStatus_DESC',
}

export const useFrameCompaniesTableData = (
  frameCompanies: FindAllFrameCompaniesResponse[]
) => {
  const [sort, setSort] = useState(SortControls.NameAsc);
  const sortedData = useMemo(() => {
    return [...sortFrameCompanies(frameCompanies, sort)];
  }, [frameCompanies, sort]);
  const columns = useMemo(() => {
    return [
      {
        Header: 'Namn',
        accessor: 'name',
        onClick: () => {
          // if (sort === SortControls.NameAsc) {
          //   return setSort(SortControls.NameDesc);
          // }
          // return setSort(SortControls.NameAsc);
        },
        iconSrc: () =>
          sort === SortControls.NameAsc ? 'ArrowDropUp' : 'ArrowDropDown',
      },
      {
        Header: 'Org.nr',
        accessor: 'registrationNumber',
        onClick: () => {
          // if (sort === SortControls.RegistrationNumberAsc) {
          //   return setSort(SortControls.RegistrationNumberDesc);
          // }
          // return setSort(SortControls.RegistrationNumberAsc);
        },
        iconSrc: () =>
          sort === SortControls.RegistrationNumberAsc
            ? 'ArrowDropUp'
            : 'ArrowDropDown',
      },
      {
        Header: 'Leverantör godkänd',
        accessor: 'supplierOk',
        onClick: () => {
          if (sort === SortControls.LatestBackgroundControlAsc) {
            return setSort(SortControls.LatestBackgroundControlDesc);
          }

          return setSort(SortControls.LatestBackgroundControlAsc);
        },
        iconSrc: () =>
          sort === SortControls.LatestBackgroundControlAsc
            ? 'ArrowDropUp'
            : 'ArrowDropDown',
      },
      {
        Header: 'Lev. Storlek',
        accessor: 'revenue',
      },
      {
        Header: 'Rapport',
        accessor: 'report',
        onClick: null,
        iconSrc: null,
      },
    ] as const;
  }, [sort]);

  const getSize = (size: string) => {
    switch (size) {
      case 'Small':
        return 'Liten';
      case 'Medium':
        return 'Mellan';
      case 'Large':
        return 'Stor';
      default:
        return 'Okänd';
    }
  };
  const data = useMemo(() => {
    return sortedData.map((contractor) => {
      const latestBackgroundControl = getLatestBackgroundControl(contractor);
      return {
        name: contractor.name,
        registrationNumber: contractor.registrationNumber,
        supplierOk: contractor.supplierOk
          ? new Date(contractor.supplierOkDoneAt).toLocaleDateString()
          : 'Nej',
        revenue: getSize(contractor.size + ''),
        optedOut: optedOutTranslation(latestBackgroundControl?.optedOut) ?? '-',
        report: getDynamicReportButton(latestBackgroundControl, contractor),
        frameCompanyId: contractor.frameCompanyId,
      };
    });
  }, [sortedData]);

  return { columns, data };
};

const optedOutTranslation = (optedOut: boolean) => (optedOut ? 'Ja' : 'Nej');

// const AcceptanceTranslation: Record<
//   BackgroundControlWithFilesRiskEnum,
//   string
// > = {
//   NoRisk: 'Inga risker identifierade.',
//   LesserRisk: 'Avvikelser identifierade, OK att samarbeta.',
//   MediumHighRisk: 'Avvikelser identifierade, åtgärder föreslås.',
//   HighRisk:
//     'Väsentliga risker. Avrådan från att anlita företaget eller åtgärda avvikelser.',
// };

function getLatestBackgroundControl(company: FindAllFrameCompaniesResponse) {
  return company.BackgroundControl.sort(
    (a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
  )[0];
}

function getDynamicReportButton(
  backgroundControl: BackgroundControlWithFiles | undefined,
  contractor: FindAllFrameCompaniesResponse
) {
  switch (backgroundControl?.risk) {
    case BackgroundControlWithFilesRiskEnum.NoRisk:
    case BackgroundControlWithFilesRiskEnum.LesserRisk:
    case BackgroundControlWithFilesRiskEnum.MediumHighRisk:
    case BackgroundControlWithFilesRiskEnum.HighRisk:
      const latestReport = findLatestReport(backgroundControl);

      return (
        <DownloadReportButton
          risk={backgroundControl.risk}
          backgroundControlId={latestReport?.backgroundControlId}
          fileName={getReportFileName(latestReport)}
        />
      );
    default:
      return <OrderBackgroundControlButton company={contractor} />;
  }
}
